import { OneWayInStatus } from 'src/api/v2';
import { StatusFilterType } from '../opportunity-table/hooks/use-status-tags';

type StatusTags = Record<StatusFilterType, (OneWayInStatus | null)[]>;

export const statusTags: StatusTags = {
  new: [null, OneWayInStatus.New, OneWayInStatus.Received, OneWayInStatus.ReferredLater],
  //Info: Opportunities should no longer get status 'Shared' from backend
  opened: [OneWayInStatus.Opened],
  wip: [OneWayInStatus.Active, OneWayInStatus.ReOpened, OneWayInStatus.Shared],
  archived: [OneWayInStatus.Closed, OneWayInStatus.Forwarded, OneWayInStatus.AutoArchived],
  recieved: [],
  onhold: [OneWayInStatus.FollowUpLater],
};
